"use client";

import React from "react";
import Image from "next/image";
import Navbar from "@/components/layout/navbar/Navbar";
import Breadcrumb from "@/components/Common/Breadcrumb";
// import Button from "@/components/ui/Button";

const Hero: React.FC = () => {
  return (
    <section className="relative w-full sm:min-h-88 bg-[#1B365E] flex flex-col items-center justify-start mb-8">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <Image
          src="/assets/contact-hero-gradient.png"
          alt="Hero Background"
          fill
          priority
          className="object-cover w-full h-full"
        />
        <div
          className="absolute inset-0 bg-[#1B365E]/55 sm:hidden"
          aria-hidden="true"
        />
      </div>

      <div className="relative z-100 w-full">
        <Navbar />
      </div>

      <div className="relative z-10 px-4 xl:px-10 pt-13.5 sm:pt-22 mb-12 sm:mb-6.5 w-full mx-auto">
        <Breadcrumb />
        <h1 className="font-red-hat font-normal text-[30px] sm:text-[48px] md:text-[60px] text-white leading-9.25 sm:leading-12.5 md:leading-19.75 tracking-[0.2px] mb-4.25 mx-auto">
          Besoin de nous contacter ?
        </h1>
        <p className="text-white text-[14px] sm:text-[20px] leading-5 sm:leading-7.5 font-medium tracking-[0.2px] sm:pt-0 pt-8 max-w-[680px]">
          Une question sur une formation, un financement ou un projet sur mesure
          ? Par téléphone, via le formulaire ou avec notre assistant, notre
          équipe vous oriente vers la formation qui répond vraiment à votre
          besoin.
        </p>
        {/* <div className="mt-8.5 flex items-start sm:items-center sm:flex-row flex-col gap-4 sm:gap-8">
          <Button className="sm:w-fit w-full" onClick={() => (window.location.href = "/quiz")}>Se laisser guider</Button>
          <Button
            className="sm:w-fit w-full"
            variant="gradient"
            onClick={() => (window.location.href = "/formations")}
          >
            Choisir votre formation
          </Button>
        </div> */}
      </div>

      <div className="flex items-center bg-white rounded-[40px] border-b border-[#40BFDE] py-3 px-4 justify-center absolute left-1/2 z-10 -translate-x-1/2 -bottom-5">
        <Image
          src="/assets/small-logo.svg"
          alt="small-logo"
          title="small-logo"
          width={30}
          height={17}
        />
      </div>
    </section>
  );
};

export default Hero;
